import { Root } from "./Root";
import { Item } from "./Item";
import {
  Trigger,
  Chevron,
  Image,
  TriggerContent,
  TriggerLabel,
  TriggerName
} from "./Trigger";
import { Content, Label, Separator, FlatItem, ItemLabel } from "./Content";
import { CheckboxItem } from "./CheckboxItem";
import { RadioItem } from "./RadioItem";
import { LinkItem } from "./LinkItem";
import { CommandMenu } from "./CommandMenu";
import { Portal } from "@radix-ui/react-dropdown-menu";

// Create and export the namespaced component
export const Dropdown = {
  Root,
  Item,
  Trigger,
  Chevron,
  Image,
  TriggerContent,
  TriggerLabel,
  TriggerName,
  Content,
  Label,
  Separator,
  FlatItem,
  ItemLabel,
  CheckboxItem,
  RadioItem,
  LinkItem,
  CommandMenu,
  Portal
};

// Export types with proper namespacing
export type {
  DropdownRootProps,
  DropdownTriggerProps,
  DropdownContentProps,
  DropdownItemProps,
  DropdownLinkItemProps,
  DropdownCheckboxItemProps,
  DropdownRadioItemProps,
  DropdownCommandMenuProps,
  DropdownTriggerContentProps,
  DropdownFlatItemProps
} from "./Dropdown.types";
